import {
    BundleItem,
    BundleProduct,
    Maybe,
    ProductInterface
} from '@pylot-data/fwrdschema'

export const getFlavourAmount = (
    product?: Maybe<BundleProduct>,
    isFavourite: Maybe<boolean> | undefined = false
): {
    flavour: Maybe<ProductInterface>
    packAmount: Maybe<number> | undefined
    pods: Maybe<BundleItem>[] | undefined
} => {
    const pods = product?.items?.filter(
        (item) => item?.ooka_product_option == 'pods'
    )
    const flavour: Maybe<ProductInterface> =
        pods?.reduce((acc, item) => {
            if (acc) return acc
            return null
        }, null as Maybe<ProductInterface>) || null

    const packAmount = flavour?.price_range?.minimum_price?.final_price?.value
    return { flavour, packAmount, pods }
}
